import { fromJS, List } from 'immutable';

export const GET_BOOK = 'kroost/book/GET_BOOK';
export const GET_BOOKS = 'kroost/book/GET_BOOKS';
export const SET_BOOK = 'kroost/book/SET_BOOK';
export const SET_BOOKS = 'kroost/book/SET_BOOKS';

// Initial routing state
const initialState = List();

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_BOOK:
      return state.push(fromJS(action.book));
    case SET_BOOKS:
      return fromJS(action.books);
    default:
      return state;
  }
}

export function getBook(id) {
  return {
    type: GET_BOOK,
    id,
  };
}

export function getBooks() {
  return {
    type: GET_BOOKS,
  };
}

export function setAll(books) {
  return {
    type: SET_BOOKS,
    books,
  };
}

export function set(book) {
  return {
    type: SET_BOOK,
    book,
  };
}



// WEBPACK FOOTER //
// ./app/redux/reducers/books.js